import { connect } from 'react-redux'
import ConvoPreview from './component'

import * as orgSelectors from 'modules/org/selectors'
import * as userSelectors from 'modules/user/selectors'

const mapStateToProps = state => ({
  name: userSelectors.getName(state),
  email: userSelectors.getEmail(state),
  color: orgSelectors.getColor(state),
  user: state.user
})

export default connect(mapStateToProps)(ConvoPreview)



// WEBPACK FOOTER //
// ./src/layouts/ConvoPreview/index.js